"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleHeaderSeparator = void 0;
var tslib_1 = require("tslib");
var Bubble_1 = require("../../Bubble");
var Typography_1 = require("../../Typography");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.BubbleHeaderSeparator = function (_a) {
    var title = _a.title, message = _a.message;
    return (react_1.default.createElement("div", { className: "gd-bubble-header-separator" },
        title ? react_1.default.createElement(Typography_1.Typography, { tagName: "h3" }, title) : null,
        message ? (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { className: "gd-bubble-header-separator-icon", showDelay: 0, hideDelay: 0 },
            react_1.default.createElement("div", { className: "gd-icon-circle-question" }),
            react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", arrowOffsets: { "tc br": [13, -10] }, alignPoints: [{ align: "tc br" }] }, message))) : null,
        react_1.default.createElement("div", { className: "gd-bubble-header-separator-divider" })));
};
//# sourceMappingURL=BubbleHeaderSeparator.js.map